import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table, message, Tooltip, InputNumber, Mention } from "antd";
import InputForm from "./InputForm";
import axios from "axios";
import "../pages/Pages.css";
import "./Form.css";
import moment from "moment-timezone";
import { maskDate } from "../utils/Masker";
import numeral from "numeral";
import JustificativaForm from '../components/JustificativaForm';

const formatHora = 'HH:mm';
const { Item: ItemForm } = Form;
const { Column } = Table;

export default class OrdemProducaoPedidosForm extends Component {
  state = {
    carregando: false,
    carregandoForm: false,

    OBSPedido: '',
    formOBSfVisivel: false,

    listaRegistros: [],
    selectedRowKeys: [],
    pi_dt_producao: moment().format('DD/MM/YYYY'),
    op_prioridade: 1,
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionadoPedido !== propsAnterior.registroSelecionadoPedido) {
      this.setState({
        registro: this.props.registroSelecionadoPedido,
        carregandoForm: true,
      }, this.getListaRegistros);
    }
  }

  componentDidMount() {

  }

  getListaRegistros = () => {
    this.setState({ carregandoForm: true, selectedRowKeys: [], listaRegistros: [] });

    let request;
    if (this.props.tipoTela === 'OP') {
      request = axios.get('/vendas/listaProdutosProducao', {
        params: {
          tipoTela: this.props.tipoTela
        }
      });
    } else {
      request = axios.get('/vendas/listaProdutosAnaliseProducao', {
        params: {
          tipoTela: this.props.tipoTela
        }
      });
    }
    request
      .then(response => {
        this.setState({
          listaRegistros: response.data,
          carregandoForm: false,
        });
      })
      .catch(erro => {
        console.warn(erro);
        this.setState({
          carregandoForm: false,
        });
      });
  };




  onOK = () => {
    const { selectedRowKeys, pi_dt_producao, op_prioridade } = this.state;

    if ((!selectedRowKeys) || (selectedRowKeys.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Selecione algum pedido' });
      return;
    }

    if (this.props.tipoTela === 'OP') {
      Modal.confirm({
        title: 'Gerar Ordem de Produção',
        content: `Deseja gerar as Ordens de Produção dos pedidos selecionados para o dia ${pi_dt_producao} ?`,
        okText: 'Sim',
        cancelText: 'Não',
        onOk: () => {

          const reg = {
            listaPedidos: selectedRowKeys,
            pi_dt_producao: moment(pi_dt_producao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            op_prioridade: op_prioridade,
          }

          // console.log('onOK: ', reg);

          this.setState({ carregando: true })

          axios.post(`/producao/storeProducaoPedidos`, reg)
            .then(response => {
              message.success('Produção gravada com sucesso.');
              this.setState({ carregando: false, selectedRowKeys: [] });
              this.props.onFecharModalPedidosClick();
            })
            .catch(error => {
              console.error(error.response);
              this.setState({
                carregando: false
              })
              Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
              this.setState({ carregando: false, selectedRowKeys: [] });
              this.props.onFecharModalPedidosClick();
            })
        }
      })
    } else {
      Modal.confirm({
        title: 'Gerar Análise Laboratorial',
        content: `Deseja gerar as análise laboratoriais dos pedidos selecionados para o dia ${pi_dt_producao} ?`,
        okText: 'Sim',
        cancelText: 'Não',
        onOk: () => {

          const reg = {
            listaPedidos: selectedRowKeys,
            pi_dt_producao: moment(pi_dt_producao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            tipo: 'PED',
          }

          // console.log('onOK: ', reg);

          this.setState({ carregando: true })

          axios.post(`/analiseProducao/storeAnalisePedidos`, reg)
            .then(response => {
              message.success('Análise gravada com sucesso');
              this.setState({ carregando: false, selectedRowKeys: [] });

              if (selectedRowKeys.length === 1) {
                this.props.onFecharModalPedidosAbrirFormClick(response.data);
              } else {
                this.props.onFecharModalPedidosClick();
              }
            })
            .catch(error => {
              console.error(error.response);
              this.setState({
                carregando: false
              })
              if (error.response.status === 412) {
                Modal.error({ title: 'Falha ao Gravar', content: error.response.data, });
              } else {
                Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
              }
            })
        }
      })
    }
  };



  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span style={{ fontSize: 11 }}>
          {dataMoment.format('DD/MM/YYYY HH:mm')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderValor = (ven_vlr_total, registro) => {
    return (
      <span style={{ fontSize: 11 }}> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderQtde = (vlr, registro) => {
    return (
      <span style={{ fontSize: 11 }}> {registro.qtde_amostras ? parseFloat(vlr) - parseFloat(registro.qtde_amostras) : parseFloat(vlr)} </span>
    );
  };

  onInputChangeQtde = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  }


  renderOBS = (pi_obs, registro) => {
    if (pi_obs) {
      return (
        <span style={{}}>
          <Tooltip title="Editar OBS">
            <a style={{ fontSize: 15, color: "rgba(0, 0, 0, 0.45)", textDecorationLine: 'underline' }}
              onClick={() => this.setState({
                formOBSfVisivel: true,
                registro: {
                  registro,
                  OBSPedido: pi_obs,
                },
              })}>
              {pi_obs}
            </a>
          </Tooltip>
        </span>
      )
    } else {
      return (
        <span style={{}}>
          <Tooltip title="Editar OBS">
            <a style={{ fontSize: 15, color: "#0000FF", textDecorationLine: 'underline' }}
              onClick={() => this.setState({
                formOBSfVisivel: true,
                registro: {
                  registro,
                  OBSPedido: '',
                },
              })}>
              Editar
            </a>
          </Tooltip>
        </span>
      )
    }
  };


  onJustifClick = (registro) => {
    const { listaRegistros } = this.state;
    const registroIndex = listaRegistros.findIndex(reg => (reg.ven_idf === registro.reg.registro.ven_idf) && (reg.vi_item === registro.reg.registro.vi_item))
    listaRegistros[registroIndex].pi_obs = registro.justificativa ? registro.justificativa : '';
    this.setState({
      listaRegistros,
      formOBSfVisivel: false,
      OBSPedido: '',
    })
  };

  onCancelarJustifClick = () => {
    this.setState({
      formOBSfVisivel: false,
      OBSPedido: '',
      registro: '',
    })
  };






  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({ [id]: value });
  };

  onInputChangePrioridade = event => {
    const value = event;
    const id = 'op_prioridade';
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  }

  onSelectChange = selectedRowKeys => {
    // console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({ selectedRowKeys });
  };





  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharModalPedidosClick, visivel, carregando } = this.props;
    const { listaRegistros, carregandoForm, selectedRowKeys, pi_dt_producao, op_prioridade, registro, formOBSfVisivel, OBSPedido } = this.state;

    // console.log('OrdemProducaoPedidosForm.this.state: ', this.state);

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;

    return (
      <Modal
        title={this.props.tipoTela === 'OP' ? "Pedidos para Produção" : "Pedidos para Análise de Laboratorial"}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharModalPedidosClick}
        footer={null}
        width={"80%"}
        style={{ top: 30 }}
      >
        <div >

          <JustificativaForm
            visivel={formOBSfVisivel}
            onJustifClick={this.onJustifClick}
            onCancelarJustifClick={this.onCancelarJustifClick}
            registro={registro}
            justificativa={OBSPedido}
            tituloTela="Observação do Pedido"
            descrCampo="Observação"
          />

          <Row style={{ height: 480 }}>
            <Row>
              <span style={{ marginTop: 8, fontSize: 15, fontWeight: 'bold' }}>
                {hasSelected ? `Selecionados ${selectedRowKeys.length} items` : ''}
              </span>

              {this.props.tipoTela === 'OP' ? (
                <Col xs={24} sm={3} style={{ marginTop: -15, paddingRight: 20 }}>
                  <span>Prioridade</span>
                  <InputNumber
                    ref="Input"
                    id={op_prioridade}
                    value={op_prioridade}
                    onChange={this.onInputChangePrioridade}
                    min={1}
                    max={3}
                    maxLength={1}
                    style={{ width: '100%' }}
                  />
                </Col>
              ) : null}
              <Col xs={24} sm={8} style={{ marginTop: -15 }}>
                <span>{this.props.tipoTela === 'OP' ? 'Data Produção' : 'Data Fabricação'}</span>
                <InputForm
                  type="date"
                  id="pi_dt_producao"
                  ref="pi_dt_producao"
                  value={pi_dt_producao}
                  masker={maskDate}
                  validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                  dateFormat="DD/MM/YYYY"
                  onChange={this.onChange}
                  errorMessage="Formato correto DD/MM/AAAA"
                  className="input-data-avaliacao"
                // style={{ width: "100%" }}
                />
              </Col>
            </Row>

            <Row style={{}}>
              <Table
                loading={{
                  spinning: carregandoForm,
                  tip: 'Carregando. Aguarde...',
                  size: "large"
                }}
                dataSource={listaRegistros}
                pagination={false}
                scroll={{ y: 360 }}
                rowKey={(listaRegistros => listaRegistros.ven_idf + '_' + listaRegistros.ven_pessoa + '_' + listaRegistros.vi_item + '_' + listaRegistros.vi_seq + '_' + listaRegistros.vi_qtde + '_' + listaRegistros.pi_obs)}

                rowSelection={rowSelection}
              >
                <Column
                  key="ven_numero"
                  dataIndex="ven_numero"
                  title="Pedido"
                  width={"10%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="ven_dt_venda"
                  dataIndex="ven_dt_venda"
                  title="Data"
                  render={this.renderData}
                  width={"13%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="pes_nome"
                  dataIndex="pes_nome"
                  title="Cliente"
                  width={"15%"}
                  align="left"
                  className="listaCadastro"
                />
                <Column
                  key="vi_qtde"
                  dataIndex="vi_qtde"
                  title="Qtde Pedido"
                  // render={this.renderQtde}
                  width={"10%"}
                  align="right"
                  className="listaCadastro"
                />
                {this.props.tipoTela === 'OP' ? null : (
                  <Column
                    key="qtde_amostras"
                    dataIndex="qtde_amostras"
                    title="Qtde Analisada"
                    // render={this.renderQtde}
                    width={"10%"}
                    align="right"
                    className="listaCadastro"
                  />
                )}
                <Column
                  key="prod_codigo"
                  dataIndex="prod_codigo"
                  title="Produto"
                  width={"10%"}
                  align="center"
                  className="listaCadastro"
                />
                <Column
                  key="prod_descricao"
                  dataIndex="prod_descricao"
                  title="Descrição do Produto"
                  width={"15%"}
                  align="left"
                  className="listaCadastro"
                />
                {this.props.tipoTela === 'OP' ? (
                  <Column
                    key="pi_obs"
                    dataIndex="pi_obs"
                    title="OBS Produção"
                    render={this.renderOBS}
                    width={"15%"}
                    align="left"
                    className="listaCadastro"
                  />
                ) : null}
              </Table>
            </Row>

          </Row>


          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  onClick={this.onOK}
                  loading={carregando}
                  className="botoesModalForm2x"
                >
                  {this.props.tipoTela === 'OP' ? 'Gerar Produção' : 'Gerar Análises'}
                </Button>

                <Button
                  htmlType="button"
                  onClick={onFecharModalPedidosClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrdemProducaoPedidosForm.js